import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  RouterProvider, createRouter, createHashHistory,
} from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import './i18n';
import { apiError, HttpStatus } from './utils/errors';
import ErrorPage from './components/status-pages/error-page';

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found');
  throw new Error('Root element not found');
}

const router = createRouter({
  routeTree,
  history: createHashHistory(),
  defaultNotFoundComponent: () => (
    <ErrorPage
      errorType={apiError(HttpStatus.NOT_FOUND, 'Settings not found')}
    />
  ),
});

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
